export class EcommerceServiceV1Impl {
    constructor(navigationService, pageId, storage) {
        this.navigationService = navigationService;
        this.pageId = pageId;
        this.storage = storage;
        this.listeners = [];
        const data = this.storage.load();
        if (data) {
            this._confirmation = data.confirmation;
            this._checkout = data.checkout;
        }
    }
    get checkout() {
        return this._checkout;
    }
    get confirmation() {
        return this._confirmation;
    }
    persist() {
        if (!this.checkout) {
            return;
        }
        this.storage.persist({
            checkout: this.checkout,
            confirmation: this.confirmation,
        });
    }
    update() {
        this.persist();
        this.listeners.forEach((listener) => listener());
    }
    startCheckout(checkout) {
        this._checkout = Object.assign({}, checkout);
        this._confirmation = undefined;
        const navigationTarget = this.navigationService.navigateTo(this.pageId, {});
        if (navigationTarget)
            navigationTarget.push();
        this.persist();
    }
    updateWebcalcRequest(data) {
        const checkout = this.checkout;
        if (checkout) {
            checkout.webCalcRequest = data;
            this.update();
        }
    }
    confirmCheckout(confirmation) {
        this._confirmation = confirmation;
        this.update();
    }
    subscribe(listener) {
        this.listeners.push(listener);
        return () => {
            const index = this.listeners.indexOf(listener);
            if (index >= 0) {
                this.listeners.splice(index, 1);
            }
        };
    }
}
//# sourceMappingURL=ecommerce-service.js.map